import { config } from "./config";
import type * as Sentry from "@sentry/react";
let client: typeof Sentry | undefined;
export function safeRoute(path: string) {
  return path
    .split(/[?#]/)[0]
    .replace(/\/in\/[^/]+/g, "/in/:accessKey")
    .replace(/\/[0-9a-f-]{20,}/gi, "/:id")
    .replace(/\/\d+(?=\/|$)/g, "/:id");
}
export async function initTelemetry() {
  if (config.mock || !config.sentryDsn) return;
  client = await import("@sentry/react");
  client.init({
    dsn: config.sentryDsn,
    environment: config.environment,
    release: "filazero-checkout-react@0.1.0",
    sendDefaultPii: false,
    integrations: [
      client.browserTracingIntegration(),
      client.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1,
    beforeSend(event) {
      delete event.user;
      delete event.extra;
      delete event.request;
      event.breadcrumbs = event.breadcrumbs
        ?.filter(
          (b) => b.category === "navigation" || b.category === "checkout",
        )
        .map((b) => ({
          ...b,
          data: {
            from: safeRoute(String(b.data?.from || "")),
            to: safeRoute(String(b.data?.to || "")),
          },
        }));
      if (event.exception?.values)
        event.exception.values.forEach((v) => {
          v.value = "Application error (details removed)";
        });
      return event;
    },
    beforeSendTransaction(event) {
      delete event.user;
      delete event.request;
      delete event.extra;
      event.transaction = safeRoute(event.transaction || "");
      event.spans?.forEach((s) => {
        s.description = safeRoute(s.description || "");
        s.data = {};
      });
      return event;
    },
  });
}
export function track(name: string) {
  performance.mark(`fz:${name}`);
  performance.clearMarks(`fz:${name}`);
  client?.metrics.count(`checkout.funnel.${name}`, 1);
  client?.addBreadcrumb({ category: "checkout", message: name, level: "info" });
}
export function report(error: unknown) {
  client?.captureException(error);
}
